// Chakra imports
import {
	Button,
	Flex,
	Icon,
	Link,
	SimpleGrid,
	Text,
	useColorModeValue,
} from "@chakra-ui/react";
// Assets
import Card from "components/card/Card";
import IconBox from "components/icons/IconBox";
import InnerContent from "layouts/innerContent";
import React from "react";
import {
	MdAutoAwesome,
	MdChevronRight,
	MdDeveloperMode,
	MdOutlineDevices,
	MdOutlineDraw,
	MdOutlineIntegrationInstructions,
	MdOutlineShoppingCart,
} from "react-icons/md";
// Custom components

export default function Service() {
	// Chakra Color Mode

	const textColor = useColorModeValue("#09090B", "white");
	const borderColor = useColorModeValue("gray.300", "white");
	return (
		<Flex
			// bg={bg}
			bgSize='cover'
			w='100%'
			direction={{ base: "column", md: "row" }}
			pb={{ base: "90px", md: "90px", lg: "100px", xl: "160px" }}
			overflow='hidden'
			position='relative'
			justifyContent='center'
			alignItems='center'>
			<Flex
				pt={{
					base: "40px",
					md: "100px",
					lg: "100px",
					xl: "100px",
					"2xl": "160px",
					"3xl": "160px",
				}}
				mx={{ base: "20px", md: "40px", "2xl": "0px" }}
				w={{ lg: "100%", "2xl": "80vw" }}
				borderRadius={{ base: "20px", md: "50px" }}
				bg='linear-gradient(180deg, #F4F4F5 0%, rgba(255, 255, 255, 0.00) 22.26%)'>
				<InnerContent px={{ base: "20px", md: "40px", xl: "0px" }}>
					<Flex
						direction='column'
						mx='auto'
						mb={{ base: "30px", md: "50px" }}
						alignItems='center'
						justify={"center"}
						textAlign='center'>
						<Text
							as='h3'
							textAlign={{ base: "center", lg: "center" }}
							fontWeight='700'
							letterSpacing='2px'
							color={textColor}
							fontSize={{ base: "xs", md: "md" }}
							w={{ base: "60%", md: "100%", lg: "100%", xl: "100%" }}
							mb='10px'>
							WHAT WE DO AND HOW WE CAN HELP YOU
						</Text>
						<Text
							as='h2'
							textAlign={{ base: "center" }}
							color={textColor}
							fontWeight='800'
							fontSize={{ base: "28px", md: "48px", lg: "48px", xl: "48px" }}
							lineHeight={{ base: "38px", md: "60px", lg: "60px", xl: "60px" }}
							w={{ base: "70%", md: "100%", lg: "100%", xl: "100%" }}
							px={{ xl: "100px" }}
							mx='auto'>
							Everything in one place
						</Text>
					</Flex>
					<SimpleGrid
						columns={{ base: "1", md: "2", lg: "3" }}
						gap='20px'
						mb={{ base: "60px", xl: "90px" }}>
						<Card
							justifyContent={"center"}
							borderRadius={{ base: "10px", md: "16px" }}
							alignItems='center'
							py='40px'>
							<IconBox
								bg='linear-gradient(180deg, #EBEBEB 0%, rgba(255, 255, 255, 0.50) 100%)'
								borderRadius='full'
								w='74px'
								h='74px'
								mb='20px'
								icon={
									<Icon
										w='34px'
										h='34px'
										color='green.500'
										as={MdDeveloperMode}
									/>
								}
							/>
							<Text
								textAlign={"center"}
								fontWeight={"bold"}
								fontSize={{ base: "lg", lg: "lg", xl: "xl" }}
								mb='8px'
								color={textColor}>
								App Development
							</Text>
							<Text
								textAlign={"center"}
								fontWeight={"500"}
								fontSize='sm'
								lineHeight='24px'
								color='#52525B'
								letterSpacing='0px'
								px={{ base: "10px", lg: "0px", xl: "14px" }}
								mb='24px'>
								From concept to launch, we create engaging and user-friendly
								mobile applications that stand out in the crowded app
								marketplace.
							</Text>
							<Link
								w={{ base: "200px", md: "200px", "2xl": "200px" }}
								href='#form'>
								<Button
									bg='transparent'
									variant='transparent'
									border='1px solid'
									borderColor={borderColor}
									color={textColor}
									my='auto'
									w={{ base: "200px", md: "200px" }}
									h='54px'
									fontSize='md'
									borderRadius='45px'>
									Hire us today
									<Icon
										as={MdChevronRight}
										color={textColor}
										mt='4px'
										ms='6px'
										h='16px'
										w='16px'
									/>
								</Button>
							</Link>
						</Card>
						<Card
							justifyContent={"center"}
							borderRadius={{ base: "10px", md: "16px" }}
							alignItems='center'
							py='40px'>
							<IconBox
								bg='linear-gradient(180deg, #EBEBEB 0%, rgba(255, 255, 255, 0.50) 100%)'
								borderRadius='full'
								w='74px'
								h='74px'
								mb='20px'
								icon={
									<Icon
										w='34px'
										h='34px'
										color='brand.500'
										as={MdOutlineDraw}
									/>
								}
							/>
							<Text
								textAlign={"center"}
								fontWeight={"bold"}
								fontSize={{ base: "lg", lg: "lg", xl: "xl" }}
								mb='8px'
								color={textColor}>
								UI/UX Design
							</Text>
							<Text
								textAlign={"center"}
								fontWeight={"500"}
								fontSize='sm'
								lineHeight='24px'
								color='#52525B'
								letterSpacing='0px'
								px={{ base: "10px", lg: "0px", xl: "24px" }}
								mb='24px'>
								Our design experts focus on creating intuitive and visually
								appealing interfaces to enhance user engagement.
							</Text>
							<Link
								w={{ base: "200px", md: "200px", "2xl": "200px" }}
								href='#form'>
								<Button
									bg='transparent'
									variant='transparent'
									border='1px solid'
									borderColor={borderColor}
									color={textColor}
									my='auto'
									w={{ base: "200px", md: "200px" }}
									h='54px'
									fontSize='md'
									borderRadius='45px'>
									Hire us today
									<Icon
										as={MdChevronRight}
										color={textColor}
										mt='4px'
										ms='6px'
										h='16px'
										w='16px'
									/>
								</Button>
							</Link>
						</Card>
						<Card
							justifyContent={"center"}
							borderRadius={{ base: "10px", md: "16px" }}
							alignItems='center'
							py='40px'>
							<IconBox
								bg='linear-gradient(180deg, #EBEBEB 0%, rgba(255, 255, 255, 0.50) 100%)'
								borderRadius='full'
								w='74px'
								h='74px'
								mb='20px'
								icon={
									<Icon
										w='34px'
										h='34px'
										color='red.500'
										as={MdOutlineDevices}
									/>
								}
							/>
							<Text
								textAlign={"center"}
								fontWeight={"bold"}
								fontSize={{ base: "lg", lg: "lg", xl: "xl" }}
								mb='8px'
								color={textColor}>
								Web Development
							</Text>
							<Text
								textAlign={"center"}
								fontWeight={"500"}
								fontSize='sm'
								lineHeight='24px'
								color='#52525B'
								letterSpacing='0px'
								px={{ base: "10px", lg: "0px", xl: "16px" }}
								mb='24px'>
								We design and develop websites that not only look stunning but
								also offer seamless functionality and a superior user
								experience.
							</Text>
							<Link
								w={{ base: "200px", md: "200px", "2xl": "200px" }}
								href='#form'>
								<Button
									bg='transparent'
									variant='transparent'
									border='1px solid'
									borderColor={borderColor}
									color={textColor}
									my='auto'
									w={{ base: "200px", md: "200px" }}
									h='54px'
									fontSize='md'
									borderRadius='45px'>
									Hire us today
									<Icon
										as={MdChevronRight}
										color={textColor}
										mt='4px'
										ms='6px'
										h='16px'
										w='16px'
									/>
								</Button>
							</Link>
						</Card>
						<Card
							justifyContent={"center"}
							borderRadius={{ base: "10px", md: "16px" }}
							alignItems='center'
							py='40px'>
							<IconBox
								bg='linear-gradient(180deg, #EBEBEB 0%, rgba(255, 255, 255, 0.50) 100%)'
								borderRadius='full'
								w='74px'
								h='74px'
								mb='20px'
								icon={
									<Icon
										w='34px'
										h='34px'
										color='orange.500'
										as={MdOutlineShoppingCart}
									/>
								}
							/>
							<Text
								textAlign={"center"}
								fontWeight={"bold"}
								fontSize={{ base: "lg", lg: "lg", xl: "xl" }}
								mb='8px'
								color={textColor}>
								E-Commerce Solutions
							</Text>
							<Text
								textAlign={"center"}
								fontWeight={"500"}
								fontSize='sm'
								lineHeight='24px'
								color='#52525B'
								letterSpacing='0px'
								px={{ base: "10px", lg: "0px", xl: "16px" }}
								mb='24px'>
								We create seamless and secure platforms that drive sales and
								provide exceptional shopping experiences for your customers.
							</Text>
							<Link
								w={{ base: "200px", md: "200px", "2xl": "200px" }}
								href='#form'>
								<Button
									bg='transparent'
									variant='transparent'
									border='1px solid'
									borderColor={borderColor}
									color={textColor}
									my='auto'
									w={{ base: "200px", md: "200px" }}
									h='54px'
									fontSize='md'
									borderRadius='45px'>
									Hire us today
									<Icon
										as={MdChevronRight}
										color={textColor}
										mt='4px'
										ms='6px'
										h='16px'
										w='16px'
									/>
								</Button>
							</Link>
						</Card>
						<Card
							justifyContent={"center"}
							borderRadius={{ base: "10px", md: "16px" }}
							alignItems='center'
							py='40px'>
							<IconBox
								bg='linear-gradient(180deg, #EBEBEB 0%, rgba(255, 255, 255, 0.50) 100%)'
								borderRadius='full'
								w='74px'
								h='74px'
								mb='20px'
								icon={
									<Icon w='34px' h='34px' color='pink.500' as={MdAutoAwesome} />
								}
							/>
							<Text
								textAlign={"center"}
								fontWeight={"bold"}
								fontSize={{ base: "lg", lg: "lg", xl: "xl" }}
								mb='8px'
								color={textColor}>
								AI App Development
							</Text>
							<Text
								textAlign={"center"}
								fontWeight={"500"}
								fontSize='sm'
								lineHeight='24px'
								color='#52525B'
								letterSpacing='0px'
								px={{ base: "10px", lg: "0px", xl: "16px" }}
								mb='24px'>
								We create intelligent bots and AI web apps that can handle
								inquiries, provide support, and improve user engagement.
							</Text>
							<Link
								w={{ base: "200px", md: "200px", "2xl": "200px" }}
								href='#form'>
								<Button
									bg='transparent'
									variant='transparent'
									border='1px solid'
									borderColor={borderColor}
									color={textColor}
									my='auto'
									w={{ base: "200px", md: "200px" }}
									h='54px'
									fontSize='md'
									borderRadius='45px'>
									Hire us today
									<Icon
										as={MdChevronRight}
										color={textColor}
										mt='4px'
										ms='6px'
										h='16px'
										w='16px'
									/>
								</Button>
							</Link>
						</Card>
						<Card
							justifyContent={"center"}
							borderRadius={{ base: "10px", md: "16px" }}
							alignItems='center'
							py='40px'>
							<IconBox
								bg='linear-gradient(180deg, #EBEBEB 0%, rgba(255, 255, 255, 0.50) 100%)'
								borderRadius='full'
								w='74px'
								h='74px'
								mb='20px'
								icon={
									<Icon
										w='34px'
										h='34px'
										color='blue.500'
										as={MdOutlineIntegrationInstructions}
									/>
								}
							/>
							<Text
								textAlign={"center"}
								fontWeight={"bold"}
								fontSize={{ base: "lg", lg: "lg", xl: "xl" }}
								mb='8px'
								color={textColor}>
								AI GPT Solutions
							</Text>
							<Text
								textAlign={"center"}
								fontWeight={"500"}
								fontSize='sm'
								lineHeight='24px'
								color='#52525B'
								letterSpacing='0px'
								px={{ base: "10px", lg: "0px", xl: "10px" }}
								mb='24px'>
								Our solutions range from predictive analytics to natural
								language processing, revolutionizing the way you process and
								utilize information.
							</Text>
							<Link
								w={{ base: "200px", md: "200px", "2xl": "200px" }}
								href='#form'>
								<Button
									bg='transparent'
									variant='transparent'
									border='1px solid'
									borderColor={borderColor}
									color={textColor}
									my='auto'
									w={{ base: "200px", md: "200px" }}
									h='54px'
									fontSize='md'
									borderRadius='45px'>
									Hire us today
									<Icon
										as={MdChevronRight}
										color={textColor}
										mt='4px'
										ms='6px'
										h='16px'
										w='16px'
									/>
								</Button>
							</Link>
						</Card>
					</SimpleGrid>
					<Flex
						direction={"column"}
						h='100%'
						w='100%'
						mx='auto'
						zIndex='3'
						justifyContent='center'
						align='center'>
						<Flex mx='auto' direction={{ base: "column", md: "row" }}>
							<Flex
								align='center'
								direction={{ base: "column", md: "row" }}
								justifyContent={{ base: "center", lg: "center" }}>
								<Link href='#form'>
									<Button
										variant='primaryGradient'
										py='20px'
										px='16px'
										fontSize='md'
										borderRadius='45px'
										me={{ base: "0px", md: "14px" }}
										mb={{ base: "20px", md: "0px" }}
										w={{ base: "300px", lg: "320px" }}
										h='70px'>
										Let’s discuss your Project
										<Icon
											as={MdChevronRight}
											w='16px'
											h='16px'
											mt='3px'
											ms='2px'
											color='white'
										/>
									</Button>
								</Link>
								<Link href='#projects'>
									<Button
										bg='transparent'
										variant='transparent'
										border='1px solid'
										borderColor={borderColor}
										color={textColor}
										my='auto'
										w={{ base: "300px", md: "200px" }}
										h='70px'
										fontSize='md'
										borderRadius='45px'>
										Explore Projects
									</Button>
								</Link>
							</Flex>
						</Flex>
					</Flex>
				</InnerContent>
			</Flex>
		</Flex>
	);
}
